module.exports = __webpack_public_path__ + "img/3.bd5a0f8e.svg";